import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'
import VueBarcode from 'vue-barcode';


export default {
	name: 'confirm-line-haul-connection',
	components: {
		Paginate,
		DatePicker,
		BasicSelect,
		VueElementLoading,
	  VueBarcode
	},
	data: function() {
		return {
			generatedBarcode:'',
			barCodeErrorMSG:'',
			barCode:'',
			shipmentData:[],
			isLoading: false,
			tripdatafound: false,
			showTable:false,
			shipmentTableData:[],
			isLoading: false,
			singlePrint:false

		}
	},
	created: function() {},
	model: {
		totalVolWt: 0,
		totalPhyWt: 0,
		totalLineHaulBags: 0,
		totalBags: 0,
		totalShipments: 0
	},
	computed: {
	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		momentDate: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY');
		},
		momentTime: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('HH:mm:ss');
		},
		toFixedNum: function(val) {
			if (val && val > 0) {
				return Number(parseFloat(val).toFixed(2));
			} else {
				return 0;
			}
		},
		jsUcfirst: function(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		getHubDetails(arr) {
			if (arr.length < 1) {
				return '';
			}

			var input = {
				hubids: [arr[(arr.length) - 1].HubID]
			}
			return axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + "expose/hubservicecenter/hubarray/get",
					'data': input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					return result.data.ResponseData[0].HubName
				}, error => {
					console.error(error)
				})
		},
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.warehouseid = userdetail[0].warehouseid;
		this.createdBy = userdetail[0].email;
		this.printDate = moment().format('DD-MM-YYYY');
		this.printBy = userdetail[0].email;
		this.tripid = this.$route.params.tripid;
		this.currenthubid = this.$route.params.currenthubid;
		this.connectionschedulemasterid = this.$route.params.connectionschedulemasterid;
		this.connectionid = this.$route.params.connectionid;
		// this.makeCode();
	},
	methods: {
		resetData(){
			this.barCodeErrorMSG='',
			this.barCode='',
			this.tripdatafound =false,
			this.shipmentData='',
			this.tripdatafound=false,
			this.showTable=false,
			this.singlePrint=false

		},
		 RVPForShippingID(data){
			 this.isLoading=true;
			this.shipmentData=[];
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getRvpDetailsForDtoSlip' + "?FlyerBarcodeNumber=" + data.AWBNumber +"&IsShippingId="+ true,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',

					}
				})
				.then(async result => {
					this.isLoading=false;
					if (result.data.ResultCode == 100) {
						this.shipmentData=result.data.ResponseData;
						this.tripdatafound = true;
						this.invalidTokenModal = false

						this.$alertify.success(result.data.ReturnMessage)
						const countCheck = await (this.shipmentData.length >0);
						const trueCheck = await (this.tripdatafound == true);

						this.printLineHaul();
					} else if (result.data.ResultCode!=100) {
						this.tripdatafound = false;
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					this.isLoading=false;
					console.error(error)
				})
		},
		showdeatils(){
			this.barCodeErrorMSG=''
			this.showTable=false;
			this.tripdatafound = false;
			if(this.barCode==''||this.barCode==undefined)
			{
				this.barCodeErrorMSG="Enter Flyer Barcode"
				return false;
			}
			this.shipmentData=[];
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getRvpDetailsForDtoSlip' + "?FlyerBarcodeNumber=" + this.barCode +"&IsShippingId="+ false,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',

					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						if(result.data.ShipmentCount == 1)
						{
						this.singlePrint=true;
						this.showTable=false;
						this.tripdatafound = true;
						this.shipmentData=result.data.ResponseData;
						this.invalidTokenModal = false
						this.$alertify.success(result.data.ReturnMessage)
					}else{
						this.showTable=true;
						this.shipmentTableData=result.data.ResponseData;
					}

					} else if (result.data.ResultCode!=100) {
						this.tripdatafound = false;
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					console.error(error)
				})


		},
		printLineHaul() {
			const d = new Printd();
			var buffer = '';
			var cssText = `

			.top{
			  top: -80px;
				position: relative;

			}
				.border{
				border-collapse: collapse;
				border-style: solid;
				border-width: 3px;

				}
				.vertical-th {
			  		transform: rotate(-90deg);
						position: relative;
						width: 10%;
					  top: 200px;
						left:90px;

					}
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               //border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             //border-style: solid;
             //border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `
			d.print(document.getElementById('tripsheetContent'), cssText);
		},
		toFixedVal(val) {
			if (val && val > 0) {
				return Number(parseFloat(val).toFixed(2));
			} else {
				return 0;
			}
		}
	},
}



// WEBPACK FOOTER //
// ./src/views/components/RVPLabel/RVPLabel.js